import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'grid-styled';
import { Map } from 'immutable';

import connect from '../store/connect';
import { fetchArticlePageView } from '../actions/actionCreators';
import Page from './Page';

import { Section } from '../styles/Section';
import { Container } from '../styles/Container';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import StoreItemCard from '../components/StoreItemCard';
import NotFoundPage from './NotFoundPage';
import ErrorPage from './ErrorPage';
import { LoadingBody, LoadingHeading, LoadingPreamble } from '../styles/LoadingState';

class StoreItemListPage extends Component {
  componentDidMount() {
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname, includeChildren: true });
  }

  render() {
    const { currentPage, request } = this.props;

    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;
    if (request.get('status') === 'LOADING')
      return (
        <Page meta={currentPage.get('metaData')} bgColor="#f2f2f2">
          <Container>
            <LoadingHeading />
            <LoadingPreamble />
            <LoadingBody />
          </Container>
        </Page>
      );

    const responsiveGridArrayFour = [1 / 2, 1 / 2, 1 / 3, 1 / 4];
    const gridPadding = ['5px', '7px', '10px'];
    const negativeGridPadding = ['-5px', '-7px', '-10px'];

    return (
      <Page meta={this.props.currentPage.get('metaData')} bgColor="#f2f2f2">
        <Container>
          <Heading big center>
            {currentPage.getIn(['fields', 'title'])}
          </Heading>
          <Preamble>{currentPage.getIn(['fields', 'introduction'])}</Preamble>
        </Container>

        <Container>
          <Section pb={80}>
            <Flex flexWrap="wrap" mx={negativeGridPadding}>
              {currentPage.get('children') &&
                currentPage.get('children').map(child => (
                  <Box key={child.get('url')} width={responsiveGridArrayFour} px={gridPadding} my={gridPadding}>
                    <StoreItemCard
                      url={child.get('url')}
                      productName={child.getIn(['fields', 'listTitle']) || child.getIn(['fields', 'productName'])}
                      brand={child.getIn(['fields', 'brand'])}
                      image={child.getIn(['fields', 'listImage']) || child.getIn(['fields', 'productImage'])}
                      tag={child.getIn(['fields', 'tag'])}
                      price={Number(child.getIn(['fields', 'productPrice']))}
                      originalPrice={Number(child.getIn(['fields', 'productOriginalPrice']))}
                    />
                  </Box>
                ))}
            </Flex>
          </Section>
        </Container>
      </Page>
    );
  }
}

StoreItemListPage.defaultProps = {
  currentPage: Map(),
  request: Map()
};

StoreItemListPage.propTypes = {
  fetchArticlePageView: PropTypes.func.isRequired,
  currentPage: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired
};

export default connect(
  StoreItemListPage,
  { fetchArticlePageView },
  (store, props) => ({
    currentPage: store.page.data.get(props.location.pathname),
    request: store.page.request.get(props.location.pathname)
  })
);



// WEBPACK FOOTER //
// ./src/pages/StoreItemListPage.js